import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

export const handleLoginClick = () => {
  const jsLoginElements = document.getElementsByClassName('js-login');

  const path =
    jsLoginElements.length > 0
      ? new URL((jsLoginElements[0] as HTMLAnchorElement).href).pathname
      : Routes.network_login_path();

  window.location.assign(
    `${path}?redirect_to=${encodeURIComponent(window.location.pathname)}`,
  );
};

const LoginWrapper = ({ redirectTo = window.location.pathname }) => (
  <Box>
    <Button
      dataTestId="login-button"
      as="a"
      // @ts-expect-error: fix types
      href={Routes.network_login_path({
        params: {
          redirect_to: redirectTo,
        },
      })}
    >
      {I18n.t('layouts.homepage_network.header.login')}
    </Button>
  </Box>
);

export default LoginWrapper;
